/**
 * StatusBadge unificado con sistema de colores tipo semaforo:
 * - Verde: listo / pagado / rentable / aprobado / firmado / confirmado / finalizado
 * - Amarillo: pendiente / revisar / parcial / por_firmar
 * - Rojo: urgente / vencido / cancelado / rechazado / perdida
 * - Azul: en proceso / en produccion / en evento / activo
 * - Gris: borrador / inactivo
 */

const COLOR_MAP = {
  // Verde - listo/exitoso
  verde: "bg-emerald-100 text-emerald-800 border-emerald-200",
  // Amarillo - atencion
  amarillo: "bg-amber-100 text-amber-800 border-amber-200",
  // Rojo - urgente/error
  rojo: "bg-red-100 text-red-800 border-red-200",
  // Azul - en proceso
  azul: "bg-blue-100 text-blue-800 border-blue-200",
  // Gris - inactivo/borrador
  gris: "bg-stone-100 text-stone-700 border-stone-200",
};

// Mapa de estatus -> (label en espanol, color semaforo)
const STATUS_MAP = {
  // Cliente
  pendiente_pago: { label: "Pendiente pago", color: "amarillo" },
  comprobante_enviado: { label: "Comprobante enviado", color: "amarillo" },
  validado: { label: "Validado", color: "verde" },
  en_diseno: { label: "En diseno", color: "azul" },
  entregado: { label: "Entregado", color: "verde" },
  seguimiento_evento: { label: "Seguimiento", color: "azul" },

  // Solicitud
  nueva: { label: "Nueva", color: "amarillo" },
  contactada: { label: "Contactada", color: "azul" },
  convertida: { label: "Convertida", color: "verde" },
  descartada: { label: "Descartada", color: "gris" },

  // Cotizacion
  borrador: { label: "Borrador", color: "gris" },
  publica: { label: "Publica", color: "azul" },
  pendiente_revision: { label: "Pendiente revision", color: "amarillo" },
  enviada: { label: "Enviada", color: "azul" },
  aprobada: { label: "Aprobada", color: "verde" },
  anticipo_solicitado: { label: "Anticipo solicitado", color: "amarillo" },
  anticipo_recibido: { label: "Anticipo recibido", color: "verde" },
  contratada: { label: "Contratada", color: "verde" },
  cancelada: { label: "Cancelada", color: "gris" },

  // Evento
  nuevo: { label: "Nuevo", color: "gris" },
  cotizado: { label: "Cotizado", color: "azul" },
  contratado: { label: "Contratado", color: "verde" },
  confirmado: { label: "Confirmado", color: "verde" },
  en_produccion: { label: "En produccion", color: "azul" },
  en_evento: { label: "En evento", color: "azul" },
  finalizado: { label: "Finalizado", color: "verde" },
  cancelado: { label: "Cancelado", color: "rojo" },

  // Pago
  pendiente: { label: "Pendiente", color: "amarillo" },
  parcial: { label: "Parcial", color: "amarillo" },
  vencido: { label: "Vencido", color: "rojo" },

  // Contrato
  firmado: { label: "Firmado", color: "verde" },
  por_firmar: { label: "Por firmar", color: "amarillo" },

  // Otros
  pagado: { label: "Pagado", color: "verde" },
  programado: { label: "Programado", color: "azul" },
  activo: { label: "Activo", color: "verde" },
  inactivo: { label: "Inactivo", color: "gris" },
  rechazado: { label: "Rechazado", color: "rojo" },
};

const StatusBadge = ({ status, customLabel, color, size = "sm", className = "", testId }) => {
  const meta = STATUS_MAP[status] || { label: customLabel || status || "—", color: color || "gris" };
  const finalLabel = customLabel || meta.label;
  const finalColor = color || meta.color;
  const colorClass = COLOR_MAP[finalColor] || COLOR_MAP.gris;
  const sizeClass = size === "lg" ? "text-sm px-3 py-1" : "text-xs px-2 py-0.5";

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border ${colorClass} ${sizeClass} ${className}`}
      data-testid={testId}
    >
      {finalLabel}
    </span>
  );
};

export default StatusBadge;
export { STATUS_MAP, COLOR_MAP };
